import React, { useEffect, useState, useRef } from 'react';
import RecorderView from './view';
import { noop } from '@client/shared/constants';

const defaultState = {
  initRecording: false,
  mediaStream: null,
  mediaRecorder: null,
  audio: null,
  analyser: null,
};

const Recorder = ({
  recordedVoicemailTitle = '',
  handleChange = noop
}) => {
  const [state, setState] = useState(defaultState);
  const canvasRef = useRef(null);

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const context = new AudioContext();
      const audioInput = context.createMediaStreamSource(stream);
      const analyser = context.createAnalyser();
      analyser.fftSize = 64;
      audioInput.connect(analyser);
      const recorder = context.createScriptProcessor(2048, 2, 2);
      analyser.connect(recorder);
      recorder.connect(context.destination);
      setState((prevState) => {
        return {
          ...prevState,
          initRecording: true,
          mediaStream: stream,
          analyser,
        };
      });
    } catch (err) {
      console.log(err);
    }
  };

  const saveRecording = () => {
    if (state.mediaRecorder?.state !== "inactive") state.mediaRecorder.stop();
  };

  const visualize = () => {
    let canvas = canvasRef.current;
    if (!canvas || !state.analyser) return;
    let canvasCtx = canvas.getContext("2d");
    const { width = 0, height = 0 } = canvas;

    let bufferLengthAlt = state.analyser.frequencyBinCount;
    let dataArrayAlt = new Uint8Array(bufferLengthAlt);
    canvasCtx.clearRect(0, 0, width, height);

    const drawAlt = () => {
      requestAnimationFrame(drawAlt);

      state.analyser.getByteFrequencyData(dataArrayAlt);

      canvasCtx.fillStyle = "rgb(255, 255, 255)";
      canvasCtx.fillRect(0, 0, width, height);

      for (let i = 0; i < bufferLengthAlt; i++) {
        canvasCtx.beginPath();
        canvasCtx.moveTo(10 * (i + 1), 0);
        canvasCtx.lineTo(10 * (i + 1), 24);
        canvasCtx.lineWidth = 4;
        canvasCtx.strokeStyle = dataArrayAlt[i] ? "#58BF5A" : "#ccc";
        canvasCtx.stroke();
      }
    };

    drawAlt();
  };

  const getWavBytes = (buffer, options) => {
    const type = options.isFloat ? Float32Array : Uint16Array
    const numFrames = buffer.byteLength / type.BYTES_PER_ELEMENT
    const headerBytes = getWavHeader(Object.assign({}, options, { numFrames }))
    const wavBytes = new Uint8Array(headerBytes.length + buffer.byteLength);
    wavBytes.set(headerBytes, 0)
    wavBytes.set(new Uint8Array(buffer), headerBytes.length)
  
    return wavBytes
  }
  const getWavHeader = (options) => {
    const numFrames =      options.numFrames
    const numChannels =    options.numChannels || 2
    const sampleRate =     options.sampleRate || 44100
    const bytesPerSample = options.isFloat? 4 : 2
    const format =         options.isFloat? 3 : 1
    const blockAlign = numChannels * bytesPerSample
    const byteRate = sampleRate * blockAlign
    const dataSize = numFrames * blockAlign
    const buffer = new ArrayBuffer(44)
    const dv = new DataView(buffer)
  
    let p = 0
  
    function writeString(s) {
      for (let i = 0; i < s.length; i++) {
        dv.setUint8(p + i, s.charCodeAt(i))
      }
      p += s.length
    }
  
    function writeUint32(d) {
      dv.setUint32(p, d, true)
      p += 4
    }
  
    function writeUint16(d) {
      dv.setUint16(p, d, true)
      p += 2
    }
  
    writeString('RIFF')              // ChunkID
    writeUint32(dataSize + 36)       // ChunkSize
    writeString('WAVE')              // Format
    writeString('fmt ')              // Subchunk1ID
    writeUint32(16)                  // Subchunk1Size
    writeUint16(format)              // AudioFormat
    writeUint16(numChannels)         // NumChannels
    writeUint32(sampleRate)          // SampleRate
    writeUint32(byteRate)            // ByteRate
    writeUint16(blockAlign)          // BlockAlign
    writeUint16(bytesPerSample * 8)  // BitsPerSample
    writeString('data')              // Subchunk2ID
    writeUint32(dataSize)            // Subchunk2Size
  
    return new Uint8Array(buffer)
  }

  useEffect(() => {
    if (state.mediaStream)
      setState((prevState) => ({
        ...prevState,
        mediaRecorder: new MediaRecorder(prevState.mediaStream),
      }));
  }, [state.mediaStream]);

  useEffect(() => {
    const recorder = state.mediaRecorder;
    let chunks = [];

    if (recorder && recorder.state === "inactive") {
      recorder.start();

      recorder.ondataavailable = (e) => {
        chunks.push(e.data);
      };

      recorder.onstop = async () => {
        //const blob = await new Blob(chunks, { type: 'audio/mp3'});
        //chunks = [];
        //setState((prevState) => {
          //if (prevState.mediaRecorder) {
            //handleChange({ name: "recordedVoicemail", value: blob }, 'custom');
            //return {
              //...defaultState,
              //audio: URL.createObjectURL(blob),
            //};
          //}
          //else {
            //return defaultState;
          //}
        //});
         const buffer = await new Blob(chunks, { type: 'audio/wav'}).arrayBuffer();
         const audioContext = new AudioContext()
         await audioContext.decodeAudioData(buffer, (audioBuffer) => {
           const left =  audioBuffer.getChannelData(0);
           const interleaved = new Float32Array(left.length)
           for (let src=0, dst=0; src < left.length; src++, dst+=1) {
             interleaved[dst] = left[src];
           }
           const wavBytes = getWavBytes(interleaved.buffer, {
             isFloat: true,      
             numChannels: 1,
             sampleRate: 48000,
           })
           const wav = new Blob([wavBytes], { type: 'audio/wav' });
           chunks = [];
           setState((prevState) => {
             if (prevState.mediaRecorder) {
               handleChange({ name: "recordedVoicemail", value: wav }, 'custom');
               return {
                 ...defaultState,
                 audio: wav,
               };
             }
             else {
               return defaultState;
             }
           });
         });
      };
    }

    return () => {
      if (recorder)
        recorder.stream.getAudioTracks().forEach((track) => track.stop());
    };
  }, [state.mediaRecorder]);

  useEffect(() => {
    if (state.initRecording) visualize();
  }, [state.initRecording]);

  return (
    <RecorderView
      initRecording={state.initRecording}
      canvasRef={canvasRef}
      recordedVoicemailTitle={recordedVoicemailTitle}
      saveRecording={saveRecording}
      startRecording={startRecording}
      handleChange={handleChange}
    />
  );
};

export default Recorder;
